export const selectedLanguage = "nn";
export const i18nextLngKey = "i18nextLng";
